import { NavigationItem } from "@/config/navigation";

interface NavigationMenuProps {
  items: NavigationItem[];
  className?: string;
  onItemClick?: () => void;
}

export const NavigationMenu = ({ items, className = "", onItemClick }: NavigationMenuProps) => {
  return (
    <nav className={className}>
      {items.map((item) => (
        <a
          key={item.label}
          href={item.href}
          onClick={onItemClick}
          className="text-sm font-medium text-foreground hover:text-primary transition-smooth relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:transition-all after:duration-300 hover:after:w-full"
        >
          {item.label}
        </a>
      ))}
    </nav>
  );
};